import { RequireResetPasswordController } from './require-reset-password.controller';
import { StateProvider, UrlRouterProvider } from "@uirouter/angularjs/lib";
import { registerComponentFromTransition } from "../core/lazy-route.helper";
import { REQUIRE_RESET_PASSWORD_COMPONENT } from "./require-reset-password.component";

export function configRoute($stateProvider: StateProvider, $urlRouterProvider: UrlRouterProvider) {
    $stateProvider.state("requireResetPassword", {
        url: "/require-reset-password",
        component: REQUIRE_RESET_PASSWORD_COMPONENT,
        lazyLoad: async (transition, state) => {
            const moduleExports: any = await import("./require-reset-password.component");
            registerComponentFromTransition(transition, REQUIRE_RESET_PASSWORD_COMPONENT, moduleExports.requireResetComponentOptions);
            return moduleExports;
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];




// WEBPACK FOOTER //
// ./app/require-reset-password/require-reset-password.router.ts